import {IconButton, makeStyles} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React from 'react'
import { useState } from 'react';
import { deepPurple } from '@material-ui/core/colors';
import { IAlreadyBooked, IMenuItem } from '../../../interface/interface';
import { v4 as uuidv4 } from 'uuid';
import { TextArea } from '../../../components/ui/TextArea';
import { canComment } from '../../../constants/constants';
import { icon_peopleMinus, icon_peoplePlus } from '../../../assets/images/images';
import { foodCategoryColors } from '../../../constants/foodCategoryColors';
import { SeatingContainer } from './SeatingContainer';
import { NumberOfPeopleInputButton } from '../../../components/ui/NumberOfPeopleInputButton';

const useStyles = makeStyles((theme: any) => ({
    container:{
        minHeight: 'fit-content',
        marginBottom: 15
    },
    dishTitleContainer:{
        display: 'flex',
        justifyContent: 'space-between',
        alignContent: 'center',
        fontWeight: 'bold'
    },
    dishDescriptionContainer:{
        height: 48,
        marginBottom: 8,
        lineHeight: "1.5rem",
        whiteSpace: 'normal',
        maxHeight: 48,
        textOverflow: "ellipsis"
    },
    priceContainer:{
        display: 'flex',
        justifyContent: "space-between",
        alignItems: 'flex-start',
        minWidth: "100%",
    },
    numberOfPeopleContainer: {
        display: 'flex',
        justifyContent: "center",
        alignItems: 'center',
        width: 'min-content',
        '& > *':{
            padding: 0
        }
    },
    numberOfPeopleInput: {
        outline: 'none',
        border: 'none',
        display: 'flex',
        justifyContent: 'center',
        alignContent: 'center',
        margin: 'auto',
        fontSize: 26,
        textAlign: 'center',
        width: 40,
        '& > *':{
            display: 'flex',
            justifyContent: 'center',
            alignContent: 'center',
            width: '100%'
        }
    },
    foodCategory: {
        width: 'fit-content',
        height: 'fit-content',
        fontSize: 10,
        color: 'white',
        display: 'flex',
        borderRadius: 50,
        padding: '3px 7px 3px',
        margin: 2,
        backgroundColor: deepPurple[500]
    },
    allergensContainer: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignContent: 'center',
        cursor: 'pointer',
    },
    timesAndOption:{
        fontSize: 16,
        fontWeight: 700
    },
    seatingsContainer:{
        display:'grid',
        gridTemplateColumns:'100%',
        width: '100%',
        justifyContent: 'center',
        columnGap: 10,
        rowGap: 10,
        marginTop: 10,
        marginBottom: 10
    },
    allergens:{
        fontSize: 10,
        fontWeight: 700,
        color: '#616161',
    },
    priceContent:{
        display: "grid",
        justifyContent: "start",
        alignItems: "end",
        gridTemplateColumns: "auto auto",
        fontSize: 18,
        columnGap: 3,
        lineHeight: 1,
        marginBottom: 6
    },
    topRowContainer:{
        marginBottom:9
    },
    foodCategoryContainer:{
        display: 'flex',
        maxWidth: '150px',
        flexWrap: "wrap",
        justifyContent: 'flex-end'
    }
}));

interface Props {
    selectedDate: Date;
    menuItemOnDate: IMenuItem;
    index: number;
    menuItemsOnDates: IMenuItem[][];
    setMenuItemsOnDates: React.Dispatch<React.SetStateAction<IMenuItem[][]>>;
    image ?: HTMLImageElement;
    price: number;
    eaterGroupBookings?: IAlreadyBooked[];
    eaterGroupName: string;
    seatingCapacities: Map<string,string>;
    canCommentOnBookings: boolean;
}

const MenuItemContainerWeekBooking: React.FC<Props> = ({selectedDate,menuItemOnDate,menuItemsOnDates,index,image,price,setMenuItemsOnDates,eaterGroupBookings,eaterGroupName,seatingCapacities,canCommentOnBookings}) => {
    const classes = useStyles();
    const [showAllergens, setShowAllergens] = useState(false);
    const [countDownView,setCountDownView] = useState<any[]>([]);

    const updateComment = (comment: string) => {
        const newMenuItems: IMenuItem [] = [];
        menuItemsOnDates[index].forEach( (selectMenuItemsOnDateItem) => {
            if(selectMenuItemsOnDateItem.dish.content.id === menuItemOnDate.dish.content.id){
                selectMenuItemsOnDateItem.comment = comment
            }
            newMenuItems.push(selectMenuItemsOnDateItem)
        });
        // Set menuItemsOnDates
        const tmpMenuItemsOnDate : IMenuItem[][] = []
        menuItemsOnDates.forEach((menuItemsOnDate,i) => {
            if(index=== i){
                tmpMenuItemsOnDate.push(newMenuItems)
            } else {
                tmpMenuItemsOnDate.push(menuItemsOnDate)
            }
        })

        if(tmpMenuItemsOnDate.length > 0){
            setMenuItemsOnDates(tmpMenuItemsOnDate)
        }
    }
 
    let viewAllergens = ''
    for (const [index, allergen] of menuItemOnDate.dish.content.allergens.entries()) {
        viewAllergens += allergen
        if(index !== menuItemOnDate.dish.content.allergens.length-1){
            viewAllergens += ', '
        }
    }

    if(viewAllergens=== ''){
        viewAllergens = 'No allergens'
    }

    const viewCategories = []
    for (const [index, foodCategory] of menuItemOnDate.dish.content.foodCategories.entries()) {
        const background = {
            backgroundColor: '#999999'
        }

        for(const [index2, value2] of foodCategoryColors.entries()){
            if (value2.category=== foodCategory) {
                background.backgroundColor = value2.color;
            }
        }
        
        viewCategories.push(<div key={foodCategory} className={classes.foodCategory} style={background}>{foodCategory}</div>)
    }

    const seatingsOnMenuItem = menuItemOnDate.selectableSeatings.map((selectableSeating) =>
        <SeatingContainer 
            key={uuidv4()}
            isWeekBooking={true}
            index={index}
            selectableSeating={selectableSeating}
            menuItemOnDate={menuItemOnDate}
            menuItemsOnDates={menuItemsOnDates}
            setMenuItemsOnDates={setMenuItemsOnDates}
            eaterGroupBookings={eaterGroupBookings?.find(eaterGroupBooking => eaterGroupBooking.seatingId === selectableSeating.seating.content.id) ? eaterGroupBookings?.find(eaterGroupBooking => eaterGroupBooking.seatingId === selectableSeating.seating.content.id) : undefined}
            eaterGroupName={eaterGroupName}
            seatingCapacity={parseInt(seatingCapacities.get(selectableSeating.seating.content.id) as string)}
        />
    );

    return (
        <div className={classes.container}>
            <div>
                <div className={classes.dishTitleContainer}>
                    <div>
                        {menuItemOnDate.dish.content.dishTitle}
                    </div>
                    <div className={classes.foodCategoryContainer}>
                        {viewCategories}
                    </div>
                </div>
                <div className={classes.dishDescriptionContainer}>
                    {menuItemOnDate.dish.content.dishDescription}
                </div>
                <div className={classes.priceContainer}>
                    <div>
                        <div className={classes.priceContent} hidden={price=== 0}>
                            {price} <div style={{fontSize:10}}>DKK</div>
                        </div>
                        <div>
                            <div>
                                {selectedDate ?
                                <div>
                                    {countDownView}
                                </div>
                                :
                                undefined
                                }
                            </div>
                            <div className={classes.allergensContainer} onClick={() => setShowAllergens(!showAllergens)} style={{marginTop: price=== 0 ? 20 : 0}}>
                                <div style={{fontSize: 12,color:"#999999"}}>
                                    See allergens <ExpandMoreIcon style={{fontSize:"1rem"}}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <NumberOfPeopleInputButton 
                        menuItemOnDate={menuItemOnDate}
                        menuItemsOnDate={menuItemsOnDates[index]}
                        menuItemsOnDates={menuItemsOnDates}
                        setMenuItemsOnDates={setMenuItemsOnDates}
                        index={index}
                    />
                </div>
            </div>
            {showAllergens ? 
                <div className={classes.allergens}>
                    {viewAllergens}
                </div>
                : null
            }
            {
                menuItemOnDate.quantity > 0 ?
                <div>
                    <div className={classes.timesAndOption}>Choose an option</div>
                    <div
                        className={classes.seatingsContainer}
                    >
                        {seatingsOnMenuItem}
                        {
                            canCommentOnBookings &&
                            <div>
                            <div className={classes.timesAndOption}>Comments</div>
                                <TextArea placeholder='Comments, notes etc' rows={2} value={menuItemOnDate.comment} onBlur={(e) => {updateComment(e.target.value)}}/>
                            </div>
                        }          
                    </div> 
                </div>
                :
                <div></div>
            }
        </div>
    );
}

export default MenuItemContainerWeekBooking;